import { Prose } from "../Prose";

export function Objective() {
  return (
    <Prose>
      Jack-of-all-trades backend engineer looking for a role in the{" "}
      <span className="font-semibold">Portland, OR</span> area or fully remote
    </Prose>
  );
}
